module.exports = __webpack_public_path__ + "img/error.4dbe322a.jpg";